import { IState } from '../../../store/reducer';

export const currentUserId = (state: IState): string => {
	return state.entities.admin.ownerImpersonationId || state.entities.auth.session.current.ownerId;
};

export const currentUserName = (state: IState): string => {
	return state.data.customers.byId[currentUserId(state)]?.name;
};

export const currentUserEmail = (state: IState): string => {
	return state.data.customers.byId[currentUserId(state)]?.email;
};

export const currentUserValidated = (state: IState): boolean => {
	return state.data.customers.byId[currentUserId(state)]?.validated;
};

export const currentUserPhone = (state: IState): string => {
	return state.data.customers.byId[currentUserId(state)]?.phone;
};
